import { generateTimeBlocks } from '../../utils';
import * as S from './styles';

export default function TimeLabelsCol() {
  const data = generateTimeBlocks();

  return (
    <S.Container>
      {data.map((time, index) => (
        <S.ColTimeLabel key={index}>
          {time.minutes === 0 && <>{time.hours}</>}
        </S.ColTimeLabel>
      ))}
    </S.Container>
  );
}
